import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { StepRecom } from '../interface/step-recom';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class StepRecomService {
  
  private apiUrl = environment.apiRoot + '/steprecom';

  constructor(private http: HttpClient) { }

  getAllStepRecomOfTrial(trialId: number): Observable<StepRecom[]> {
    return this.http.get<StepRecom[]>(this.apiUrl + '/alloftrial?trialId=' + trialId);
  }

  getAllStepRecomOfTestStep(testStepId: number): Observable<StepRecom[]> {
    return this.http.get<StepRecom[]>(this.apiUrl + '/allofteststep?testStepId=' + testStepId);
  }

  createStepRecom(testStepId: number): Observable<StepRecom> {
    let model = { "id": 0, "test_step_id": testStepId, "sn": "new rec." };
    return this.http.post<StepRecom>(this.apiUrl + '/new', model);
  }

  updateStepRecom(model: StepRecom): Observable<StepRecom> {
    return this.http.put<StepRecom>(this.apiUrl + '/update', model);
  }

  deleteStepRecom(StepRecomId: number): Observable<string> {
    return this.http.delete<string>(this.apiUrl + '/delete?StepRecomId=' + StepRecomId);
  }

}
